module.exports = __webpack_public_path__ + "amazon.svg?c77fd3d1786d13c9d4c1c0c1523130a5";